
export { stringIsValidDate } from "/home/runner/work/apollo/apollo/packages/core/utils/validations/src/string-is-valid-date/string-is-valid-date.ts"